import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import decimalHint from 'scaleflow/utils/decimal-hint';

export default class BusinessMetricsMetricEditController extends Controller {
  @tracked activeStep = 0;
  @tracked metricChangeset = {};
  @tracked isSaving = false;
  @tracked isAdvancedOpen = false;

  @service betaToggle;
  @service store;
  @service router;

  @action
  setActiveStep(index) {
    this.activeStep = index;
  }

  @action
  toggleAdvanced() {
    this.isAdvancedOpen = !this.isAdvancedOpen;
  }

  @action
  decimalHint(val) {
    return decimalHint(val, Number(this.metricChangeset.decimals));
  }

  @action
  onDescriptionChange(changeset, e) {
    changeset.set('description', e);
  }

  @action
  async saveMetric() {
    this.isSaving = true;
    try {
      this.metricChangeset.changes.forEach((change) => {
        this.model.set(change.key, change.value);
      });
      await this.model.save();
      this.goToListPage();
    } finally {
      this.isSaving = false;
    }
  }

  @action
  rollbackChanges(changeset) {
    if (!changeset) {
      this.metricChangeset.rollback();
    } else changeset.rollback();
  }

  @action
  goToListPage() {
    this.router.transitionTo('business.metrics');
  }

  @action
  onFormCancel() {
    this.rollbackChanges();
    this.goToListPage();
  }
}
